import React from 'react';
import { AccountParams } from '../model/AccountParams';

const AccountContext = React.createContext<AccountParams>({ host: '', modules: [] });

export { AccountContext };